import { render, staticRenderFns } from "./hot.vue?vue&type=template&id=f5c05b96"
import script from "./hot.vue?vue&type=script&lang=js"
export * from "./hot.vue?vue&type=script&lang=js"
import style0 from "./hot.vue?vue&type=style&index=0&id=f5c05b96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports